<template>
	<div>
		<v-carousel height="360px">
			<v-carousel-item
				v-for="(item,i) in images"
				:key="i"
				:src="item.src"
				reverse-transition="fade-transition"
				transition="fade-transition"
			></v-carousel-item>
		</v-carousel>

		<v-card
			class="mt-5 pa-4"
			outlined
			tile
		>

			<p><b>Официальное наименование:</b> Государственное учреждение образования "Центр коррекционно-развивающего обучения и реабилитации г. Бобруйска"</p>
			<p><b>Тип учреждения:</b> Учреждение специального образования</p>
			<p><b> Населенный пункт:</b> Бобруйск</p>
			<p><b>Адрес:</b> г. Бобруйск ул. Орджоникидзе, 40</p>
			<p><b>Режим работы:</b> 7:30 - 18:00</p>
			<p><b>Телефоны:</b> 78-04-34</p>
			<p><b>E-mail:</b> bobr.ckroir@tut.by</p>
			<p><b>Регистрационный номер:</b> 7141917692 от 07.02.2019</p>
		</v-card>

        <v-card
            class="mx-auto mt-5"
            outlined
            tile
        >

            <v-list-item three-line>

                <v-list-item-content>
                    <div class="overline mb-4">НОВОСТИ | 25.03.2020</div>
                    <v-list-item-title class="headline mb-1">«Магия добра»</v-list-item-title>
                    <v-list-item-subtitle>
                    Совместное музыкально-развлекательное мероприятие «Магия добра» прошло 6 декабря с участием отделения дневного пребывания инвалидов учреждение «Территориальный центр социального обслуживания населения Ленинского района г.Бобруйска».
                </v-list-item-subtitle>
                </v-list-item-content>

            <v-list-item-avatar
            tile
            size="80"
            color="grey"
            >

                <v-img
                    :src="`http://ckroir.bobruisk.edu.by/sm.aspx?guid=14853`"
                    :lazy-src="`http://ckroir.bobruisk.edu.by/sm.aspx?guid=14853`"
                    aspect-ratio="1"
                    class="grey lighten-2"
                ></v-img>

            </v-list-item-avatar>
            </v-list-item>

            <v-card-actions>
            <v-btn text>Открыть</v-btn>
            </v-card-actions>
        </v-card>
	</div>
</template>

<script>
	export default {
		data: function() {
			return {
				images: [
					{ src: 'http://ckroir.bobruisk.edu.by/sm.aspx?guid=5703' },
					{ src: 'http://www.bobrlife.by/wp-content/uploads/2019/12/1M6A4889.jpg', },
					{ src: 'http://www.bobrlife.by/wp-content/uploads/2019/12/1M6A4896.jpg' },
				],
			}
		}
	}
</script>

<style>
	
</style>